import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import BuildingConstant from "../Constants/BuildingConstants";

let getBuildingListResult = [];
let addorUpdateBuidResult = [];
let delBuidResult = [];

class BuildingStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getBuildingListResult() {
    return getBuildingListResult;
  }

  setBuildingListResult(result) {
    getBuildingListResult = result;
  }

  getAddUpdateBuildResult() {
    return addorUpdateBuidResult;
  }

  setAddUpdateBuildResult(result) {
    addorUpdateBuidResult = result;
  }

  getDelBuildResult() {
    return delBuidResult;
  }

  setDelBuildResult(result) {
    delBuidResult = result;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case BuildingConstant.GET_BUILDING_LIST_SUCCESS:
        this.setBuildingListResult(action.result);
        break;
      case BuildingConstant.GET_BUILDING_LIST_FAILURE:
        this.setBuildingListResult(action.result);
        break;
      case BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_SUCCESS:
        this.setAddUpdateBuildResult(action.result);
        break;
      case BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_FAILURE:
        this.setAddUpdateBuildResult(action.result);
        break;
      case BuildingConstant.DEL_BUILDING_SUCCESS:
        this.setDelBuildResult(action.result);
        break;
      case BuildingConstant.DEL_BUILDING_FAILURE:
        this.setDelBuildResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const buildingStore = new BuildingStore();
dispatcher.register(buildingStore.handleCallback.bind(buildingStore));
export default buildingStore;
